export function plural(string: string, isPlural: boolean = true) {
  return string.split(' ').map(word => `${word}${isPlural ? 's' : ''}`).join(' ');
}
